<template>
  <div class="menue-left" @mouseenter="mouseState='in'" @mouseleave="mouseState='out'">
    <MenuTop @searchChange="searchChange"></MenuTop>
    <div v-if="defaultSettings.leftMenuType=='default'" class="menue-left-box">
      <ul class="menue-left-box-ul" v-for="(item,key0) in menusList" :key="key0">
        <div class="menue-left-box-ul-title" @click="shousuoHandle(item,key0)" :title="$t(item?.meta?.title)">
          <!-- width: 16px; -->
          <img
            
            v-if="menusArr.includes(item?.meta?.title)"
            :src="require(`@/assets/menu/${menusArr.indexOf(item?.meta?.title)+1}.png`)"
            alt=""
            srcset="">
          <a-icon v-else-if="(typeof item.meta.icon == 'object')" slot="prefix" :component="item.meta.icon" />
          <a-icon v-else slot="prefix" :type="item.meta.icon" />
          <span class="font16B">{{ $t(item?.meta?.title) }}</span>
        </div>
        <div v-if="!item.shousuo" class="menue-left-box-ul-children">
          <template v-for="(itemChild,key1) in item.childrenMenu">
            <div
              v-if="itemChild.isLangSwitch"
              :key="key1"
              class="router-link lang-switch-item"
              @click="langVisible = !langVisible">
              <span class="router-link-title font14M">{{ $t(itemChild?.meta?.title) }}</span>
              <span class="lang-current">{{ currentLangName }}</span>
              <a-popover
                v-model="langVisible"
                trigger="click"
                placement="rightTop"
                overlayClassName="left-menu-lang-popover"
                :getPopupContainer="() => $el">
                <template slot="content">
                  <div
                    class="lang-option"
                    v-for="lang in languageList"
                    :key="lang.value"
                    :class="{ active: currentLang === lang.value }"
                    @click="switchLang(lang.value)">
                    <span>{{ lang.name }}</span>
                    <a-icon v-if="currentLang === lang.value" type="check" />
                  </div>
                </template>
              </a-popover>
            </div>
            <router-link
              v-else
              class="router-link"
              active-class="active-router-link"
              :key="key1"
              :to="'/'+itemChild?.path"
              :title="$t(itemChild?.meta?.title)">
              <span class="router-link-title font14M">
                {{ $t(itemChild?.meta?.title) }}
              </span>
            </router-link>
          </template>
        </div>
      </ul>
    </div>
    <div v-if="defaultSettings.leftMenuType=='unfold'" class="menue-left-box  menue-unfold">
      <ul class="menue-left-box-ul" v-for="(item,key0) in menusList" :key="key0">
        <div class="menue-left-box-ul-title" @click="shousuoHandle(item,key0)" :title="$t(item?.meta?.title)">
          <!-- width: 16px; -->
          <div style="display: flex;align-items: center;">
            <img
              
              v-if="menusArr.includes(item?.meta?.title)"
              :src="require(`@/assets/menu/${menusArr.indexOf(item?.meta?.title)+1}.png`)"
              alt=""
              srcset="">
            <a-icon v-else-if="(typeof item.meta.icon == 'object')" slot="prefix" :component="item.meta.icon" />
            <a-icon v-else slot="prefix" :type="item.meta.icon" />
            <span class="font16B">{{ $t(item?.meta?.title) }}</span>
          </div>
          <div style="display: flex;align-items: center;">
            <a-icon v-if="!item.shousuo" type="down" style="color: #fff;font-size: 12px;"/>
            <a-icon v-else type="up" style="color: #fff;font-size: 12px;" />
          </div>
        </div>
        <div v-if="!item.shousuo" class="menue-left-box-ul-children">
          <template v-for="(itemChild,key1) in item.childrenMenu">
            <div
              v-if="itemChild.isLangSwitch"
              :key="key1"
              class="router-link lang-switch-item"
              @click="langVisible = !langVisible">
              <span class="router-link-title font14M">{{ $t(itemChild?.meta?.title) }}</span>
              <span class="lang-current">{{ currentLangName }}</span>
              <a-popover
                v-model="langVisible"
                trigger="click"
                placement="rightTop"
                overlayClassName="left-menu-lang-popover"
                :getPopupContainer="() => $el">
                <template slot="content">
                  <div
                    class="lang-option"
                    v-for="lang in languageList"
                    :key="lang.value"
                    :class="{ active: currentLang === lang.value }"
                    @click="switchLang(lang.value)">
                    <span>{{ lang.name }}</span>
                    <a-icon v-if="currentLang === lang.value" type="check" />
                  </div>
                </template>
              </a-popover>
            </div>
            <router-link
              v-else
              class="router-link"
              active-class="active-router-link"
              :key="key1"
              :to="'/'+itemChild?.path"
              :title="$t(itemChild?.meta?.title)">
              <span class="router-link-title font14M">
                {{ $t(itemChild?.meta?.title) }}
              </span>
            </router-link>
          </template>
        </div>
      </ul>
    </div>

    <div class="menue-left-footer" v-if="nickname" v-click-outside="closeUserPanel">
      <div class="menue-left-user" @click="toggleUserPanel">
        <a-avatar size="small" :src="avatar" class="user-avatar" />
        <div class="user-text">
          <span class="user-name">{{ nickname }}</span>
          <span class="user-role">{{ accountType }}</span>
        </div>
        <a-icon type="up" :class="['user-arrow', { 'is-open': userPanelVisible }]" />
      </div>
      <transition name="user-panel-slide">
        <div v-show="userPanelVisible" class="user-panel">
          <div class="user-panel-header">
            <span class="user-panel-name">{{ nickname }}</span>
            <span class="user-panel-id">账号ID {{ userInfo.userId }}</span>
            <span class="user-panel-role">{{ accountType }}</span>
          </div>
          <div class="user-panel-body">
            <div class="user-panel-item" @click="handleToPage('/system/logininfor')">
              <a-icon type="file-text" />
              <span>操作日志</span>
            </div>
            <div class="user-panel-item" @click="handleToPage('/account/settings')">
              <a-icon type="user" />
              <span>个人中心</span>
            </div>
            <div class="user-panel-item" @click="clearCache">
              <a-icon type="reload" />
              <span>清除缓存</span>
            </div>
          </div>
          <div class="user-panel-footer">
            <a-button type="default" block @click="handleLogout">退出登录</a-button>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="defaultSettings.leftMenuShrink" class="menue-left-icon" :class="mouseState=='out'?'mouse-out':'mouse-in'" @click="setMenuStatus" @mouseenter="mouseState='in'">
      <img
       class="menue-left-icon-hidden"
        :src="hiddenImg"
      />
      <img
       class="menue-left-icon-open"
        :src="openImg"
      />
    </div>
  </div>
</template>

<script>
import MenuTop from '../MenuTop'
import Icon from 'ant-design-vue/es/icon'
import defaultSettings from '@/config/defaultSettings';
import hiddenImg from './img/hidden.png'
import openImg from './img/open.png'
import i18nMixin from '@/store/i18n-mixin'
import { mapGetters } from 'vuex'
import { Modal } from 'ant-design-vue'

export default {
  mixins: [i18nMixin],
  components: {
    MenuTop,
    Icon
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el._clickOutsideHandler = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression]()
          }
        }
        document.addEventListener('click', el._clickOutsideHandler, true)
      },
      unbind(el) {
        document.removeEventListener('click', el._clickOutsideHandler, true)
      }
    }
  },
  props: {
    menus: {
      type: Array,
      require: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      searchMenu: '',
      menusArr: ['驾驶舱', '用户管理', '场地管理', '设备管理', '财务管理', '运营中心', '运维工单', '系统设置'],
      defaultSettings,
      hiddenImg,
      openImg,
      mouseState:'out',
      langVisible: false,
      userPanelVisible: false,
      languageList: [
        { value: 'zh-CN', name: '简体中文' },
        { value: 'en-US', name: 'English' }
      ]
    }
  },
  computed: {
    ...mapGetters(['avatar', 'nickname', 'userInfo']),
    accountType() {
      let text = '主账号'
      if (this.userInfo?.roleList?.length > 0) {
        const roleNames = []
        this.userInfo.roleList.forEach(item => {
          roleNames.push(item.roleName)
        })
        text = roleNames.join(',')
      }
      return text
    },
    currentLangName() {
      const item = this.languageList.find(l => l.value === this.currentLang)
      return item ? item.name : '简体中文'
    },
    menusList() {
      const list = []
      this.menus.forEach(item => {
        if (!item.hidden) {
          let isSearchResult = false // 是否有搜索出结果
          if (item.children) {
            const children = item.children.filter((mapItem) => {
              if (!mapItem.hidden) {
                // 如果用户使用搜索菜单
                if (this.searchMenu) {
                  // 如果这个一级菜单下有搜索结果
                  if (mapItem?.meta?.title.indexOf(this.searchMenu) !== -1||this.$t(mapItem?.meta?.title).indexOf(this.searchMenu) !== -1) {
                    isSearchResult = true
                    return mapItem
                  }
                } else {
                  return mapItem
                }
              }
            })
            item['childrenMenu'] = children
          } else {
            item['childrenMenu'] = []
          }

          // 在「系统设置」分组下追加语言切换项
          if (!this.searchMenu && item?.meta?.title === '系统设置' && Array.isArray(item.childrenMenu)) {
            item.childrenMenu.push({
              meta: { title: '语言切换' },
              path: '',
              isLangSwitch: true
            })
          }

          // 如果用户使用搜索菜单
          if (this.searchMenu) {
            // 如果这个一级菜单下有搜索结果
            if (isSearchResult) {
              list.push(item)
            }
          } else {
            list.push(item)
          }
        }
      })
      console.log('list>>>>', list)

      return list
    }
  },
  created() {
    console.log('菜单>>>>>', this.menus)
    console.log('菜单>>>>>menusList>>>>', this.menusList)
  },
  methods: {
    // 搜索菜单
    searchChange(name) {
      this.searchMenu = name
    },
    toggleUserPanel() {
      this.userPanelVisible = !this.userPanelVisible
    },
    closeUserPanel() {
      this.userPanelVisible = false
    },
    // 点击收缩
    shousuoHandle(item, key0) {
      // item['shousuo'] = !item?.shousuo
      if (item.shousuo) {
        this.$set(item, 'shousuo', false)
      } else {
        this.$set(item, 'shousuo', true)
      }
    },
    setMenuStatus() {
      this.$store.dispatch('setMenuHidden',!this.menuHidden)
    },
    // 切换语言
    switchLang(value) {
      this.setLang(value)
      this.langVisible = false
      window.location.reload()
      localStorage.setItem('LANGUAGE_SCREEN_TYPE', value)
    },
    // 跳转页面
    handleToPage(path) {
      if (path) {
        this.$router.push({ path })
      }
    },
    // 清除缓存
    clearCache() {
      location.reload()
    },
    // 退出登录
    handleLogout() {
      Modal.confirm({
        title: '提示',
        content: '确定注销并退出系统吗？',
        onOk: () => {
          return this.$store.dispatch('Logout').then(() => {
            location.href = '/index'
          })
        }
      })
    }
  }

}
</script>

<style lang="less" scoped>

.menue-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 220px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background: #0f172a;
  z-index: 1100;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08);

  .menue-left-box {
    flex: 1;
    padding: 0 12px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    .menue-left-box-ul {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0;
      margin-bottom: 4px;

      .menue-left-box-ul-title {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 12px 14px;
        margin-bottom: 2px;
        border-radius: 6px;
        cursor: pointer;
        transition: background 0.2s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.04);
        }

        img,
        /deep/ .anticon {
          height: 18px;
          width: 18px;
          font-size: 18px;
          color: #94a3b8;
          margin-right: 12px;
          flex-shrink: 0;
        }

        /deep/ .anticon {
          height: auto;
        }

        span {
          color: #e2e8f0;
          font-size: 14px;
          font-weight: 500;
        }
      }

      .menue-left-box-ul-children {
        display: flex;
        flex-direction: column;
        width: 100%;

        .router-link {
          position: relative;
          width: 100%;
          padding: 9px 14px 9px 44px;
          margin-bottom: 2px;
          text-align: left;
          border-radius: 6px;
          color: #94a3b8;
          transition: all 0.2s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.04);
            color: #e2e8f0;
          }

          .router-link-title {
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            line-height: 1.4;
            font-size: 13px;
          }
        }

        .active-router-link {
          background: rgba(40, 120, 255, 0.1);
          color: #60a5fa;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: #2878FF;
            border-radius: 0 2px 2px 0;
          }

          .router-link-title {
            color: #60a5fa;
            font-weight: 500;
          }
        }
      }
    }

    &.menue-unfold {
      padding: 0 12px;

      .menue-left-box-ul {
        .menue-left-box-ul-title {
          justify-content: space-between;
          padding-left: 14px;
          padding-right: 12px;

          > div {
            display: flex;
            align-items: center;
          }

          /deep/ .anticon {
            color: #64748b;
            font-size: 12px;
          }
        }

        .menue-left-box-ul-children {
          .router-link {
            padding-left: 44px;
            padding-top: 9px;
            padding-bottom: 9px;
          }

          .active-router-link {
            background: rgba(40, 120, 255, 0.1);

            .router-link-title {
              color: #60a5fa;
            }
          }
        }
      }
    }
  }

  .menue-left-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 40%;
    right: -16px;
    background-color: #1e293b;
    border: 1px solid rgba(255, 255, 255, 0.08);
    transition: 0.3s ease-in-out;
    visibility: hidden;
    opacity: 0;
    width: 16px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 0 8px 8px 0;
    z-index: 999999999999;
    cursor: pointer;

    img {
      width: 10px;

      &.menue-left-icon-open {
        display: none;
      }
    }

    &.mouse-in {
      visibility: visible !important;
      opacity: 1 !important;
    }
  }

  .lang-switch-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .lang-current {
      font-size: 12px;
      color: #64748b;
      margin-left: auto;
      padding-left: 8px;
    }

    &:hover {
      .lang-current {
        color: #94a3b8;
      }
    }
  }

  .menue-left-footer {
    position: relative;
    flex-shrink: 0;
    padding: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);

    .menue-left-user {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      border-radius: 6px;
      cursor: pointer;
      transition: background 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.06);
      }

      .user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 10px;
        flex-shrink: 0;
        background: rgba(255, 255, 255, 0.1);
      }

      .user-text {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 0;
        overflow: hidden;

        .user-name {
          font-size: 13px;
          color: #e2e8f0;
          font-weight: 500;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .user-role {
          font-size: 11px;
          color: #64748b;
          line-height: 1.3;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .user-arrow {
        font-size: 10px;
        color: #64748b;
        margin-left: 8px;
        flex-shrink: 0;
        transition: transform 0.2s ease;

        &.is-open {
          transform: rotate(180deg);
        }
      }

      &:hover {
        background: rgba(255, 255, 255, 0.06);
      }
    }

    .user-panel {
      position: absolute;
      left: 12px;
      right: 12px;
      bottom: calc(100% + 8px);
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 6px 26px rgba(0, 0, 0, 0.12);
      padding: 20px;
      z-index: 9999;
      transform-origin: bottom center;

      &-header {
        display: flex;
        flex-direction: column;
        padding-bottom: 16px;
        border-bottom: 1px solid #f0f0f0;

        .user-panel-name {
          font-size: 16px;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 6px;
        }

        .user-panel-id {
          font-size: 13px;
          color: #9ca3af;
          margin-bottom: 10px;
        }

        .user-panel-role {
          display: inline-flex;
          align-self: flex-start;
          padding: 4px 12px;
          font-size: 13px;
          color: #2878FF;
          background: rgba(40, 120, 255, 0.08);
          border: 1px solid rgba(40, 120, 255, 0.25);
          border-radius: 4px;
        }
      }

      &-body {
        padding: 10px 0;

        .user-panel-item {
          display: flex;
          align-items: center;
          padding: 11px 0;
          cursor: pointer;
          transition: color 0.15s ease;

          .anticon {
            font-size: 15px;
            color: #6b7280;
            margin-right: 12px;
          }

          span {
            font-size: 14px;
            color: #374151;
          }

          &:hover {
            span {
              color: #2878FF;
            }

            .anticon {
              color: #2878FF;
            }
          }
        }
      }

      &-footer {
        padding-top: 8px;

        /deep/ .ant-btn {
          height: 40px;
          border-radius: 6px;
          font-size: 14px;
          color: #6b7280;
          background: #f3f4f6;
          border: none;

          &:hover {
            color: #374151;
            background: #e5e7eb;
          }
        }
      }
    }

    .user-panel-slide-enter-active,
    .user-panel-slide-leave-active {
      transition: all 0.2s ease;
    }

    .user-panel-slide-enter,
    .user-panel-slide-leave-to {
      opacity: 0;
      transform: translateY(10px) scale(0.96);
    }
  }
}
</style>
